var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentTrustly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    viewBox: "0 0 36 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 19,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2047 12.4001V8.4593H11.7839V7.6001H15.5615V8.4641H14.1407V12.4001H13.2047Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4559 12.4V8.9104H16.3247V9.4624C16.5503 8.9968 16.8335 8.9104 17.1359 8.9104H17.4767V9.784H17.1791C16.7375 9.784 16.3487 10.0384 16.3487 10.8112V12.3952H15.4559V12.4Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9712 11.1376V8.9152H18.864V10.9264C18.864 11.3728 19.0944 11.6704 19.5024 11.6704C19.896 11.6704 20.1888 11.3728 20.1888 10.9312V8.9104H21.0816V12.4H20.2176V11.9584C19.992 12.3088 19.6464 12.4768 19.2096 12.4768C18.4752 12.4816 17.9712 11.9872 17.9712 11.1376Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5568 11.4161L22.344 11.2385C22.3824 11.5457 22.632 11.7521 23.0496 11.7521C23.3904 11.7521 23.5872 11.6081 23.5872 11.4209C23.5872 11.2673 23.496 11.1665 23.1648 11.0849L22.5984 10.9553C21.936 10.8017 21.624 10.4897 21.624 9.90894C21.624 9.31854 22.1184 8.84814 23.0208 8.84814C23.976 8.84814 24.3696 9.41454 24.4224 9.82254L23.6352 9.99534C23.5968 9.77934 23.4336 9.54894 23.0016 9.54894C22.7184 9.54894 22.5072 9.67854 22.5072 9.86574C22.5072 10.0289 22.632 10.1201 22.824 10.1681L23.592 10.3505C24.192 10.4945 24.48 10.8449 24.48 11.3585C24.48 11.9201 24.024 12.4721 23.0544 12.4721C21.9984 12.4673 21.6048 11.8433 21.5568 11.4161Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3183 12.4C25.7183 12.4 25.3391 12.0592 25.3391 11.4208V9.68801H24.7583V8.91041H25.3391V8.11841L26.2319 7.86401V8.91521H26.9423V9.69281H26.2319V11.272C26.2319 11.5264 26.3567 11.6272 26.6159 11.6272H27.0047V12.4H26.3183Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5903 12.4001V7.6001H28.4831V12.4001H27.5903Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.44 8.91528H32.4L30.9264 13.6529H29.9664L30.3744 12.4049H29.8896L28.896 8.91528H29.856L30.6144 11.6609L31.44 8.91528Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 9.7025H5.84158V7.9169L7.62718 9.7025L5.84158 11.4881V12.4001H8.00638V9.7025H9.99838V7.6001H3.59998V9.7025Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 19,
    rx: 1.5,
    stroke: "#DADADA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentTrustly);
export default __webpack_public_path__ + "static/media/payment-trustly.a50ee9d604a2522082fa141891cfaec3.svg";
export { ForwardRef as ReactComponent };